export enum PermissionOperationsOption {
  DASHBOARD_COMMON_LOGIN = 'operacion',
  DASHBOARD_LIST = '/operacion/',
  DASHBOARD_EDIT_SERVICE = 'dashboards.services.edit',
  DASHBOARD_CANCEL_SERVICE = 'dashboards.services.cancel',
  DASHBOARD_VIEW_EVIDENCE_SERVICE = 'dashboards.services.view_evidence',
  DASHBOARD_VIEW_GPS = 'dashboards.services.view_fake_gps',
}
